const lang = {
  title: '招待',
  message: {
    accept: '参加しました。',
    deny: '拒否しました。'
  },
  button: {
    accept: '参加',
    deny: '拒否',
    back: '戻る'
  },
  subtitle: 'の共同作業に参加しますか？',
  content_title: '共同作業とは',
  content_body: '撮影作業を複数名で同時に行うことができます。<br> さらに、現場と事務所のリアルタイム連携で、<br> 撮影と報告書作成、編集の分業が可能になります。',
  empty_name: '「案件名未入力」',
  modalFreeAccountLimit: {
    modal_header: 'お知らせ',
    modal_content: '<b>無料アカウント</b>で参加が</br>できるのは１案件のみです。</br></br><b>有料アカウント</b>では期間や件数の</br>制限なく共同作業ができます。',
    btn_redirect: '今すぐ申し込む'
  }
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/acceptInvite.js